import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  compliance: {
    padding: theme.spacing(1),
  },
  complianceText: {
    display: 'flex',
    alignItems: 'center',
    color: '#828282',
    fontStyle: 'italic',
  },
}));

export const ComplianceMessage = () => {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={11} classes={{ root: classes.complianceText }}>
            <Typography variant="caption">
              Minimize risk by validating adherence to compliance standards with
              component owners.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
